document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".custom-faq").forEach((faq) => {
    faq.querySelectorAll(".custom-faq__question").forEach((button) => {
      button.addEventListener("click", () => {
        const item = button.closest(".custom-faq__item");

        faq.querySelectorAll(".custom-faq__item").forEach((i) => {
          if (i !== item) {
            i.classList.remove("active");
            i.querySelector(".custom-faq__question").setAttribute(
              "aria-expanded",
              "false",
            );
          }
        });

        item.classList.toggle("active");

        button.setAttribute("aria-expanded", item.classList.contains("active"));
      });
    });
  });
});
